import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

import { EthereumAddress } from '@/utils/models';

export interface SwapFeeStore {
  swapFeeBps: number | undefined;
  swapFeeRecipient: EthereumAddress | undefined;
  swapFeeToken: EthereumAddress | undefined;
  setSwapFeeBps: (swapFeeBps: number | undefined) => void;
  setSwapFeeRecipient: (swapFeeRecipient: EthereumAddress | undefined) => void;
  setSwapFeeToken: (swapFeeToken: EthereumAddress | undefined) => void;
}

export const useSwapFeeStore = createWithEqualityFn<SwapFeeStore>()(
  (set) => ({
    swapFeeBps: undefined,
    swapFeeRecipient: undefined,
    swapFeeToken: undefined,
    setSwapFeeBps: (swapFeeBps: number | undefined) =>
      set({
        swapFeeBps,
      }),
    setSwapFeeRecipient: (swapFeeRecipient: EthereumAddress | undefined) =>
      set({
        swapFeeRecipient,
      }),
    setSwapFeeToken: (swapFeeToken: EthereumAddress | undefined) =>
      set({
        swapFeeToken,
      }),
  }),
  shallow,
);
